<template>
  <v-badge
    :content="count"
    :value="count > 0"
    color="primary500"
    class="notification-bell"
    bordered
    overlap
  >
    <fai class="text-h5 link grey100--text" :icon="icon" />
  </v-badge>
</template>

<script>
export default {
  props: {
    count: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    icon() {
      if (this.count > 0) return ['fas', 'bell']
      return ['far', 'bell']
    },
  },
}
</script>

<style lang="scss" scoped>
.notification-bell {
  ::v-deep .v-badge__badge::after {
    border-color: grey(600);
  }
}
</style>
